import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[section-host]',
  standalone: false
})
export class SectionDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
